import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendObtenerConfiguracionesNotificacion,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/obtenerConfiguracionesNotificacion.json";
import mock_Json1 from "../../../dataJson/obtenerConfiguracionesNotificacion1.json";
import mock_Json2 from "../../../dataJson/obtenerConfiguracionesNotificacion2.json";
import mock_Json3 from "../../../dataJson/obtenerConfiguracionesNotificacion3.json";
import { formatearMensajeBackend } from "../../../apis/helper/helperApi";
import { TypeStatus } from "../../helpers/constantes";

import {
  IConfiguracionNotificacion,
  IObtenerConfiguracionesRequest,
} from "../../../interfaces/backendApi/configuracionNotificacion";

interface State {
  status: TypeStatus;
  isLoading: boolean;
  error: string | null;
  configuracionesNotificaciones: IConfiguracionNotificacion[];
  Success: boolean;
  Mensaje: string;
}

const initialState: State = {
  status: "idle",
  isLoading: false,
  error: null,
  configuracionesNotificaciones: [],
  Success: false,
  Mensaje: "",
};

interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}

const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};

const obtenerConfiguracionesNotificacionSlice = createSlice({
  name: "obtenerConfiguracionesNotificacion",
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setConfiguracionesNotificacion: (
      state,
      action: PayloadAction<IConfiguracionNotificacion[]>,
    ) => {
      state.configuracionesNotificaciones = action.payload;
    },
    appendConfiguracionesNotificacion: (
      state,
      action: PayloadAction<IConfiguracionNotificacion[]>,
    ) => {
      // Merge/upsert: reemplaza la entrada con mismo ValorDato o agrega si no existe
      const incoming = action.payload;
      const current = state.configuracionesNotificaciones;
      const merged = [...current];
      incoming.forEach((newItem) => {
        const itemValorDato = newItem.ValorDato;
        const idx =
          itemValorDato !== undefined && itemValorDato !== null && itemValorDato !== ""
            ? merged.findIndex((c) => String(c.ValorDato) === String(itemValorDato))
            : -1;
        if (idx >= 0) {
          merged[idx] = newItem;
        } else {
          merged.push(newItem);
        }
      });
      state.configuracionesNotificaciones = merged;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setClearObtenerConfiguracionesNotificacion: (state) => {
      return initialState;
    },
  },
});

export const setBackendObtenerConfiguracionesNotificacion =
  (datos: IObtenerConfiguracionesRequest): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));

      try {
        const response: AxiosResponse =
          await BackendObtenerConfiguracionesNotificacion(datos);

        const isError =
          response.data?.Success === false ||
          (response.data?.ResultadoSolicitud !== undefined &&
            response.data?.ResultadoSolicitud !== 200);

        if (isError) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          dispatch(setConfiguracionesNotificacion(response.data.Data || []));
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));

        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setSuccess(false));
        dispatch(setStatus("failed"));

        if (error.response?.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        } else if (error.response) {
          // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
          console.error(
            "Error de servidor:",
            error.response.status,
            error.response.data,
          );

          const errorData = error.response.data;
          const mensajeBackend = errorData?.Mensaje;
          const resultadoSolicitud = errorData?.ResultadoSolicitud;

          if (
            mensajeBackend &&
            (resultadoSolicitud !== 200 || errorData?.Success === false)
          ) {
            dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
          } else {
            dispatch(
              setMensaje(
                `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
              ),
            );
          }
        } else if (error.request) {
          console.error("Error de conexión:", error.message);
          dispatch(
            setMensaje(
              "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
            ),
          );
        } else {
          console.error("Error de red o solicitud:", error.message);
          dispatch(
            setMensaje(
              "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
            ),
          );
        }
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          dispatch(setIsLoading(true));
          let response: AxiosResponse = defaultResp;
          response.data = mock_Json;

          const mockData: any = mock_Json;
          const isErrorMock =
            mockData?.Success === false ||
            (mockData?.ResultadoSolicitud !== undefined &&
              mockData?.ResultadoSolicitud !== 200);

          if (isErrorMock) {
            dispatch(setIsLoading(false));
            dispatch(setStatus("failed"));
            dispatch(setSuccess(false));
          } else {
            dispatch(setConfiguracionesNotificacion(response.data.Data || []));
            dispatch(setIsLoading(false));
            dispatch(setStatus("succeeded"));
            dispatch(setSuccess(true));
          }
          dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
          const mock401 = await import("../../../dataJson/401.json");
          if (mock401.status === 401) {
            dispatch(setStatus("noAutorice"));
            dispatch(
              setMensaje(
                formatearMensajeBackend(
                  "Tu sesión ha expirado. Vuelve a iniciar sesión",
                ),
              ),
            );
          }
          return response.data;
        }
      }
    };

export const setBackendClearObtenerConfiguracionesNotificacion =
  (): Thunk =>
    async (dispatch): Promise<AxiosResponse | AxiosError> => {
      dispatch(setIsLoading(true));
      try {
        let response: AxiosResponse = defaultResp;
        dispatch(setConfiguracionesNotificacion([]));
        dispatch(setIsLoading(false));
        dispatch(setStatus("idle"));
        dispatch(setSuccess(false));
        dispatch(setMensaje(""));
        return response.data;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        return error as AxiosError;
      } finally {
        dispatch(setIsLoading(false));
      }
    };

export const {
  setIsLoading,
  setStatus,
  setConfiguracionesNotificacion,
  appendConfiguracionesNotificacion,
  setSuccess,
  setMensaje,
  setError,
  setClearObtenerConfiguracionesNotificacion,
} = obtenerConfiguracionesNotificacionSlice.actions;

/**
 * Thunk que llama a la API una vez por cada perfil, acumula todos los resultados
 * en memoria local y hace UN ÚNICO dispatch al final con todos los datos consolidados.
 * Evita pasar ValorDato vacío y evita múltiples actualizaciones intermedias del estado.
 */
export const setBackendObtenerConfiguracionesNotificacionAllPerfiles =
  (perfilesIds: string[]): Thunk =>
    async (dispatch): Promise<void> => {
      if (perfilesIds.length === 0) return;
      dispatch(setIsLoading(true));
      dispatch(setStatus("loading"));

      try {
        // Esperar TODAS las respuestas en paralelo, sin fallar si alguna falla
        const settled = await Promise.allSettled(
          perfilesIds.map((id) =>
            BackendObtenerConfiguracionesNotificacion({
              TipoDato: "Perfil",
              ValorDato: String(id),
            }).then((response) => ({ id, response })),
          ),
        );

        // Acumular en memoria local: un IConfiguracionNotificacion por perfil
        const allConfigs: IConfiguracionNotificacion[] = [];

        settled.forEach((result) => {
          if (result.status === "fulfilled") {
            const { id, response } = result.value;
            const rawData = response.data?.Data;

            if (Array.isArray(rawData) && rawData.length > 0) {
              // Detectar si ya viene en formato envuelto (tiene Permisos)
              // o en formato plano (tiene evento/Tipos por item)
              const firstItem = rawData[0];

              if (firstItem.Permisos) {
                // Formato envuelto: la API ya devolvió IConfiguracionNotificacion[]
                // Usar el primero que coincida o crear uno con el id del perfil
                const wrapped = rawData.find((item: any) =>
                  String(item.ValorDato) === String(id)
                ) || rawData[0];
                allConfigs.push({
                  TipoDato: wrapped.TipoDato || "Perfil",
                  ValorDato: String(id),
                  Permisos: wrapped.Permisos,
                });
              } else {
                // Formato plano: array de { evento: { Codigo }, Tipos: [{ Codigo }] }
                // Transformar a UN SOLO IConfiguracionNotificacion con Permisos[]
                const permisos = rawData.map((item: any) => ({
                  Evento: item.evento?.Codigo ?? item.Evento,
                  Tipos: (item.Tipos || item.tipos || [])
                    .map((t: any) => (typeof t === "object" ? t.Codigo : t))
                    .filter((t: number) => t != null),
                }));

                allConfigs.push({
                  TipoDato: "Perfil",
                  ValorDato: String(id),
                  Permisos: permisos,
                });
              }
            }
          }
        });
        console.log(allConfigs)
        // Un único dispatch con todos los datos de todos los perfiles
        dispatch(setConfiguracionesNotificacion(allConfigs));
        dispatch(setSuccess(true));
        dispatch(setStatus("succeeded"));
      } catch {
        dispatch(setStatus("failed"));
      } finally {
        dispatch(setIsLoading(false));
        if (getCurrentDomain() === "localhost") {
          // Simula lo que ocurriría en test: una llamada por perfil con datos distintos.
          // Rotamos entre los 4 mocks disponibles para que cada perfil tenga
          // configuraciones diferentes (igual que lo haría el backend real).
          const mockJsonPool: any[] = [mock_Json, mock_Json1, mock_Json2, mock_Json3];

          const extractPermisos = (mockData: any) =>
            ((mockData as any).Data || []).map((item: any) => ({
              Evento: item.evento?.Codigo ?? item.Evento,
              Tipos: (item.Tipos || item.tipos || [])
                .map((t: any) => (typeof t === "object" ? t.Codigo : t))
                .filter((t: number) => t != null),
            }));

          const mockDataPerProfile: IConfiguracionNotificacion[] = perfilesIds.map((id, index) => ({
            TipoDato: "Perfil",
            ValorDato: String(id),
            Permisos: extractPermisos(mockJsonPool[index % mockJsonPool.length]),
          }));
          console.log(mockDataPerProfile)
          dispatch(setConfiguracionesNotificacion(mockDataPerProfile));
          dispatch(setSuccess(true));
          dispatch(setStatus("succeeded"));
          return;
        }

      }
    };

export default obtenerConfiguracionesNotificacionSlice.reducer;
